export default __webpack_public_path__ + "static/media/image91.94ef55fa.jpg";